"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_use_1 = require("react-use");
var useInterval_1 = __importDefault(require("./useInterval"));
/**
 * Returns the time (in seconds) a user has
 * been active on the page for.
 *
 * @param timeToIdle Incative time in seconds before user is considered idle.
 */
function useTimeActive(timeToIdle, interval) {
    if (timeToIdle === void 0) { timeToIdle = 20; }
    if (interval === void 0) { interval = 5; }
    var isIdle = react_use_1.useIdle(timeToIdle * 1000);
    var _a = __read(react_1.useState(0), 2), time = _a[0], setTime = _a[1];
    var _b = __read(react_1.useState(new Date().getTime()), 2), lastActive = _b[0], setLastActive = _b[1];
    useInterval_1.default(function () {
        if (!isIdle) {
            setTime(time + interval * 1000);
            setLastActive(new Date().getTime());
        }
    }, interval * 1000);
    react_1.useEffect(function () {
        if (isIdle) {
            var activeTime = new Date().getTime() - lastActive;
            setTime(time + activeTime);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isIdle]);
    var reset = react_1.useCallback(function () {
        setTime(0);
    }, []);
    return [Math.round(time / 1000), reset];
}
exports.default = useTimeActive;
//# sourceMappingURL=useTimeActive.js.map